module.exports = __webpack_public_path__ + "01_baby.747709b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/01_baby.png
// module id = kstm
// module chunks = 0